// Azure migration: update API endpoint and key for Azure resources
//export const domain = 'https://api.test.tis.coke.com';
export const domain = 'https://apiazr.dev.tis.coke.com';
export const stage = 'dev';

export const featureFlags = {
  authorization: true
};
